/**
 * Estrutura dos daods do Floorplan
 */
export default [
    {
        id: 503,
        name: '10º Pavimento - ED. Residencial',
        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2F503-d85c-1570742200472.jpg?alt=media&token=d85c229a-212f-48da-96df-3a208e903e38',
        construcode_areas: [],
        viewpoints: [
            {
                id: 5290,
                name: 'Apto 1001 - Banho Dormitório 01',
                x: 3315,
                y: 601,
                images: [
                    {
                        id: 10749,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F246-fc80-1564411187066.jpg?alt=media&token=fc802b84-5607-4af0-9050-1017c17d7230',
                        date: '29/07/2021 10:33',
                        yaw_offset: 92.1429,
                        issues: [],
                    },
                    {
                        id: 10748,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5290-ced023f2-5541-4786-bdc0-cd53f14e2f1c.jpg?alt=media&token=b267f608-4506-42a1-939b-157d2bd94eb2',
                        date: '29/05/2021 00:00',
                        yaw_offset: 170.156,
                        issues: [],
                    },
                    {
                        id: 10747,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5290-2eadf5ae-2168-4900-9289-a3c63af44cc2.jpg?alt=media&token=acb26ec5-6167-4b25-8e9a-72e2e1dce10e',
                        date: '20/05/2021 00:00',
                        yaw_offset: -0.669643,
                        issues: [],
                    },
                    {
                        id: 10746,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5290-70eb5b5a-f7df-45f5-9bba-bf74868adeac.jpg?alt=media&token=84ed8503-31a5-4f45-b0fd-7bcac42c3f98',
                        date: '13/05/2021 00:00',
                        yaw_offset: 0.669643,
                        issues: [],
                    },
                    {
                        id: 10745,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5290-476c3554-e197-4043-9f81-a79c81da7870.jpg?alt=media&token=d3bd43fd-c27f-461e-8781-685869441fbf',
                        date: '06/05/2021 00:00',
                        yaw_offset: 170.156,
                        issues: [],
                    },
                ],
            },
            {
                id: 5294,
                name: 'Apto 1001 - Banho Dormitório 02',
                x: 5197,
                y: 710,
                images: [
                    {
                        id: 10776,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F250-8a33-1564411187760.jpg?alt=media&token=8a3397df-7b68-4791-9944-6163e1c0fd84',
                        date: '29/07/2021 10:33',
                        yaw_offset: -95.2902,
                        issues: [
                            {
                                id: 5939,
                                code: 3,
                                priority: 'high',
                                title: 'Fissura Acabamento',
                                text: 'Refazer acabamento de parede.\n\nFissura é superficial, logo é necessário apenas refazer parte do reboco.',
                                status: 'closed',
                                due_days: 4,
                                due_date: '22/11/2021',
                                type: {
                                    id: 970,
                                    label: 'Pendência',
                                    name: 'Empreiteiro',
                                },
                                cause: {
                                    id: 649,
                                    label: 'Qualidade',
                                    name: 'Acabamento inadequado',
                                },
                                sector: {
                                    id: 347,
                                    name: 'a',
                                },
                                floorplan: {
                                    id: 503,
                                    name: '10º Pavimento - ED. Residencial',
                                },
                                viewpoint: {
                                    id: 5294,
                                    name: 'Apto 1001 - Banho Dormitório 02',
                                },
                                image: {
                                    id: 10776,
                                    date: '29/07/2019 10:33',
                                },
                                pitch: -13.0926,
                                yaw: 154.441,
                                thumbnail:
                                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F0c7265da-8c53-496e-ae94-611aa8e66e22.png?alt=media&token=383d1796-9087-4623-b81e-d559c4474959',
                                attachment_thumbnail: null,
                                tags: [
                                    {
                                        id: 170,
                                        members: [
                                            {
                                                email: 'emilio.bier@constructin.com.br',
                                            },
                                        ],
                                    },
                                ],
                                subjects: [
                                    {
                                        id: 1181,
                                        code: 'INT',
                                        name: 'Interiores',
                                    },
                                ],
                                comment_count: 2,
                                events: [
                                    {
                                        id: 13783,
                                        type: 'comment',
                                        comment: {
                                            id: 13783,
                                            text: 'resolvido! Segue foto',
                                            edited: false,
                                            attachments: [],
                                        },
                                        created_at: '17/11/2021 14:18',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13784,
                                        type: 'comment',
                                        comment: {
                                            id: 13784,
                                            text: '',
                                            edited: false,
                                            attachments: [
                                                {
                                                    id: 930,
                                                    name: 'image_picker_8A13F896-9997-4049-BD09-9A43C635A0E5-78800-00000D262FF13945.jpg',
                                                    url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2Fcd64cb00-2ba1-4d1f-9ae3-e73aa1412e41.txt?alt=media&token=0fa4569a-0fba-4eb6-9863-1ad394e017a6',
                                                    type: 'jpeg',
                                                },
                                            ],
                                        },
                                        created_at: '17/11/2021 14:20',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13785,
                                        type: 'to_review',
                                        comment: null,
                                        created_at: '17/11/2021 14:20',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13795,
                                        type: 'close',
                                        comment: null,
                                        created_at: '18/11/2021 05:27',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13796,
                                        type: 'reopen',
                                        comment: null,
                                        created_at: '18/11/2021 05:27',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13797,
                                        type: 'close',
                                        comment: null,
                                        created_at: '18/11/2021 05:27',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                ],
                                attachments: [],
                                created_at: '17/11/2021 13:54',
                                created_by: {
                                    id: 657,
                                    email: 'owner@constructin.com.br',
                                    name: 'Construct IN',
                                    surname: '',
                                },
                                to_review_at: null,
                                closed_at: '18/11/2021 05:27',
                            },
                        ],
                    },
                    {
                        id: 10775,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5294-07ff9911-cea2-4e5b-b7f9-666128270159.jpg?alt=media&token=4403dd3c-3a26-4902-8a9a-3000a2f28104',
                        date: '24/06/2021 00:00',
                        yaw_offset: 93.4821,
                        issues: [],
                    },
                    {
                        id: 10774,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5294-a05c84f2-0a58-4d79-9a84-c22f783181e2.jpg?alt=media&token=86bf09e5-b7b5-4027-8764-34d0198c3e48',
                        date: '29/05/2021 00:00',
                        yaw_offset: -14.7321,
                        issues: [],
                    },
                    {
                        id: 10773,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5294-2eb88929-d113-4b3b-b535-d76441b68e66.jpg?alt=media&token=654436e2-94d9-4f59-a894-f8349091b379',
                        date: '20/05/2021 00:00',
                        yaw_offset: 1.40625,
                        issues: [],
                    },
                    {
                        id: 10772,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5294-7a49a1f6-1c03-4060-9991-86c60d620e2b.jpg?alt=media&token=12bd2409-fda7-4846-8eec-2f7a69ea6011',
                        date: '13/05/2021 00:00',
                        yaw_offset: 10.5804,
                        issues: [],
                    },
                    {
                        id: 10771,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5294-13c6e7be-0c61-4ae8-8fc6-12ba54c30f18.jpg?alt=media&token=774fae88-6107-4cd4-a67a-ba2b2a55d056',
                        date: '06/05/2021 00:00',
                        yaw_offset: -11.9196,
                        issues: [],
                    },
                    {
                        id: 10770,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5294-5db4c941-d769-4b1a-a721-7f3d28a8dd68.jpg?alt=media&token=6102a994-ad70-4878-a866-2bee7282e837',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5287,
                name: 'Apto 1001 - Circulação',
                x: 2755,
                y: 1050,
                images: [
                    {
                        id: 10730,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5287-4308ee6b-935e-4ac9-b0a9-dfd8646f21f2.jpg?alt=media&token=2de8f3ec-3837-4727-ab2a-cbd4c800cfb3',
                        date: '24/06/2021 00:00',
                        yaw_offset: 79.0848,
                        issues: [],
                    },
                    {
                        id: 10729,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5287-d6cb9ea7-7983-4312-b043-fc743f84e1e0.jpg?alt=media&token=1810e5f2-9030-4730-ba99-080a2901cd1c',
                        date: '29/05/2021 00:00',
                        yaw_offset: -3.14732,
                        issues: [],
                    },
                    {
                        id: 10728,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5287-5b32b3be-3d27-4100-8df2-67e993a5d3ef.jpg?alt=media&token=4be561fc-06bc-45b7-8655-912fc32eb47d',
                        date: '20/05/2021 00:00',
                        yaw_offset: 93.4821,
                        issues: [],
                    },
                    {
                        id: 10727,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5287-9f27d061-df77-4e67-bfa5-5d9849dce8a2.jpg?alt=media&token=05779454-b1c7-4e7a-86ae-1ecb52b45a51',
                        date: '13/05/2021 00:00',
                        yaw_offset: 118.125,
                        issues: [],
                    },
                ],
            },
            {
                id: 5289,
                name: 'Apto 1001 - Circulação 02',
                x: 3353,
                y: 1041,
                images: [
                    {
                        id: 10743,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F245-92f2-1564411215419.jpg?alt=media&token=92f2a8cd-91f1-4da2-bbd6-62977c8b523c',
                        date: '29/07/2021 10:34',
                        yaw_offset: 8.4375,
                        issues: [],
                    },
                    {
                        id: 10742,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5289-1cee868f-b48d-4200-a791-17b9712c37c5.jpg?alt=media&token=e086177d-cc83-46a7-baab-e84a28b088b3',
                        date: '29/05/2021 00:00',
                        yaw_offset: -10.5804,
                        issues: [],
                    },
                    {
                        id: 10741,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5289-d91f5aa6-6ab7-4b50-8600-a28446885a8d.jpg?alt=media&token=cc4b4980-e30e-45ba-88dc-492c4811c63e',
                        date: '20/05/2021 00:00',
                        yaw_offset: 100.58,
                        issues: [],
                    },
                    {
                        id: 10740,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5289-c54fca7e-ab7a-446e-912a-f011bced7256.jpg?alt=media&token=8a1fde9e-b62b-4505-ae50-8f4e6c616b23',
                        date: '13/05/2021 00:00',
                        yaw_offset: 93.8839,
                        issues: [],
                    },
                ],
            },
            {
                id: 5292,
                name: 'Apto 1001 - Circulação 03',
                x: 3921,
                y: 1044,
                images: [
                    {
                        id: 10762,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F248-dfd7-1564411216174.jpg?alt=media&token=dfd70321-c6c9-4679-b6f1-6fef76d653ca',
                        date: '29/07/2021 10:34',
                        yaw_offset: -84.375,
                        issues: [],
                    },
                    {
                        id: 10761,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5292-9262dabf-e241-455c-bfaa-d3b69b2410a4.jpg?alt=media&token=56b1f804-4c92-493e-8323-6cf69e76e2ea',
                        date: '24/06/2021 00:00',
                        yaw_offset: 91.0714,
                        issues: [],
                    },
                    {
                        id: 10760,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5292-083afcc8-b064-418b-935b-49f79cd60c07.jpg?alt=media&token=8968368a-094f-4222-83f1-6f3ab25f51a5',
                        date: '29/05/2021 00:00',
                        yaw_offset: -51.6964,
                        issues: [],
                    },
                    {
                        id: 10759,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5292-af8b5885-fc20-4894-8d82-b13d1f5b2a0a.jpg?alt=media&token=11d43bd1-ae87-413c-9f63-d036758b1283',
                        date: '20/05/2021 00:00',
                        yaw_offset: 12.9911,
                        issues: [],
                    },
                    {
                        id: 10758,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5292-ad166d6d-055c-44f2-b473-e0f3917676ed.jpg?alt=media&token=b809ffd9-7c3b-4833-b4da-1d85f167b855',
                        date: '13/05/2021 00:00',
                        yaw_offset: 80.8929,
                        issues: [],
                    },
                    {
                        id: 10757,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5292-89732aba-c42c-4fcd-bce3-2e590247e56d.jpg?alt=media&token=50bd6f0d-239c-438b-87ee-3f9d31ff8a08',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5284,
                name: 'Apto 1001 - Cozinha',
                x: 2249,
                y: 645,
                images: [
                    {
                        id: 10712,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F240-7a36-1564411147074.jpg?alt=media&token=7a36580e-491e-4bb9-bdc6-ea175384741c',
                        date: '29/07/2021 10:32',
                        yaw_offset: -10.5804,
                        issues: [],
                    },
                    {
                        id: 10711,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5284-b843b5bb-20c0-404b-9705-170d98ceae1a.jpg?alt=media&token=820e6677-0b1b-4472-88ab-c2dd3411de0d',
                        date: '29/05/2021 00:00',
                        yaw_offset: -97.7679,
                        issues: [],
                    },
                    {
                        id: 10710,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5284-5a005773-209e-4f79-8848-2ce95989595a.jpg?alt=media&token=207096d3-65c9-4f77-a714-7681a6f7cd57',
                        date: '20/05/2021 00:00',
                        yaw_offset: 46.0714,
                        issues: [],
                    },
                    {
                        id: 10709,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5284-91305cd1-c5be-4c8d-8998-2e46746f4214.jpg?alt=media&token=217853d6-9bf4-4586-9652-c45b0a5d9aad',
                        date: '13/05/2021 00:00',
                        yaw_offset: 72.7902,
                        issues: [],
                    },
                    {
                        id: 10707,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5284-a4698cf6-2be1-4fe8-9bac-5daa6b3fc66e.jpg?alt=media&token=a2bce80c-62cc-41b6-80af-51690e688332',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5285,
                name: 'Apto 1001 - Cozinha 02',
                x: 2610,
                y: 381,
                images: [
                    {
                        id: 10717,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F241-9e1d-1564411147075.jpg?alt=media&token=9e1d68eb-ce95-4553-bcf0-17af8ece671d',
                        date: '29/07/2021 10:32',
                        yaw_offset: -131.116,
                        issues: [],
                    },
                    {
                        id: 10716,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5285-66b2fa97-c6ce-40b5-88be-2c43d42e6eed.jpg?alt=media&token=bc769786-c712-4fd8-89d6-4f32efd7c459',
                        date: '29/05/2021 00:00',
                        yaw_offset: -5.95982,
                        issues: [],
                    },
                    {
                        id: 10715,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5285-58d88010-d5a3-423c-bc25-06c5742cdf84.jpg?alt=media&token=b05f632c-6c47-438d-9d1a-6f679aefd058',
                        date: '20/05/2021 00:00',
                        yaw_offset: -3.88393,
                        issues: [],
                    },
                    {
                        id: 10714,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5285-0fefb218-ec2e-4cd3-abec-5b068900dc8d.jpg?alt=media&token=a6e38533-62d3-4a51-afb7-effff0ff2575',
                        date: '13/05/2021 00:00',
                        yaw_offset: -32.3438,
                        issues: [],
                    },
                    {
                        id: 10713,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5285-e9b099b9-2fcf-452d-8b21-391576d0ead7.jpg?alt=media&token=c2b8ce87-5689-4686-aea3-4d0d70c950c9',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5291,
                name: 'Apto 1001 - Dormitório 01',
                x: 3838,
                y: 563,
                images: [
                    {
                        id: 10756,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F247-7f3f-1564411187780.jpg?alt=media&token=7f3f1f77-adee-4eb8-be0a-bc242988afef',
                        date: '29/07/2021 10:34',
                        yaw_offset: -53.7723,
                        issues: [],
                    },
                    {
                        id: 10755,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5291-42294032-866a-4cb0-b13d-491439e7c542.jpg?alt=media&token=7f936977-25ad-49eb-92e6-74179b9ae0f2',
                        date: '24/06/2021 00:00',
                        yaw_offset: 62.2098,
                        issues: [],
                    },
                    {
                        id: 10754,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5291-b5e1b5b3-796d-4624-a1c1-b0afc8f32eea.jpg?alt=media&token=2984b705-365e-49d8-8417-abe68df597e0',
                        date: '29/05/2021 00:00',
                        yaw_offset: 92.8125,
                        issues: [],
                    },
                    {
                        id: 10753,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5291-c9295406-768e-4198-a77b-8c9b4b110107.jpg?alt=media&token=74f4a127-f5e6-4015-ada8-ef27bd204b35',
                        date: '20/05/2021 00:00',
                        yaw_offset: 2.14286,
                        issues: [],
                    },
                    {
                        id: 10752,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5291-9fc2d428-515a-49c4-92f5-24c0e7ec8587.jpg?alt=media&token=2d5de75f-1f6a-42ee-bd46-c9cc2f1bf62c',
                        date: '13/05/2021 00:00',
                        yaw_offset: 0.669643,
                        issues: [],
                    },
                    {
                        id: 10751,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5291-0514ce77-e9a8-485c-a103-88ca6e22d5a6.jpg?alt=media&token=8cff7a71-f51d-4bce-b8e4-b600d176026f',
                        date: '06/05/2021 00:00',
                        yaw_offset: 86.8527,
                        issues: [],
                    },
                ],
            },
            {
                id: 5293,
                name: 'Apto 1001 - Dormitório 02',
                x: 4625,
                y: 669,
                images: [
                    {
                        id: 10769,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F249-b0a3-1564411187065.jpg?alt=media&token=b0a355c6-d22c-472c-a619-669384898121',
                        date: '29/07/2021 10:33',
                        yaw_offset: -153.616,
                        issues: [
                            {
                                id: 5938,
                                code: 2,
                                priority: 'high',
                                title: 'Requadro janela dormitório',
                                text: 'Requadrar janela com acabamento para evitar infiltração.\n\nEm anexo, segue exemplo de instalação correta.\n\nNaomi, empreiteira responsável - cuidar para demais janelas.',
                                status: 'open',
                                due_days: 1,
                                due_date: '19/11/2021',
                                type: {
                                    id: 970,
                                    label: 'Pendência',
                                    name: 'Empreiteiro',
                                },
                                cause: {
                                    id: 649,
                                    label: 'Qualidade',
                                    name: 'Acabamento inadequado',
                                },
                                sector: {
                                    id: 347,
                                    name: 'a',
                                },
                                floorplan: {
                                    id: 503,
                                    name: '10º Pavimento - ED. Residencial',
                                },
                                viewpoint: {
                                    id: 5293,
                                    name: 'Apto 1001 - Dormitório 02',
                                },
                                image: {
                                    id: 10769,
                                    date: '29/07/2019 10:33',
                                },
                                pitch: 9.6782,
                                yaw: 10.8491,
                                thumbnail:
                                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F4d552171-de94-4f7e-adf7-c3d2e66a55d2.png?alt=media&token=ee5e34b4-fcc0-43db-b5f6-ec6a3afb0548',
                                attachment_thumbnail: null,
                                tags: [
                                    {
                                        id: 170,
                                        members: [
                                            {
                                                email: 'naomi.trindade@constructin.com.br',
                                            },
                                        ],
                                    },
                                ],
                                subjects: [
                                    {
                                        id: 1173,
                                        code: 'ARQ',
                                        name: 'Arquitetura',
                                    },
                                    {
                                        id: 1181,
                                        code: 'INT',
                                        name: 'Interiores',
                                    },
                                ],
                                comment_count: 1,
                                events: [
                                    {
                                        id: 13786,
                                        type: 'comment',
                                        comment: {
                                            id: 13786,
                                            text: 'anotado, requadro realizado',
                                            edited: false,
                                            attachments: [],
                                        },
                                        created_at: '17/11/2021 14:21',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                ],
                                attachments: [
                                    {
                                        id: 937,
                                        name: 'JanelaCIN.png',
                                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F67ede576-8f7b-4ba5-b8e5-b88dc1b05592.png?alt=media&token=17c7a789-0dc6-44f4-afd4-e39847ed7017',
                                        type: 'png',
                                    },
                                ],
                                created_at: '17/11/2021 13:44',
                                created_by: {
                                    id: 657,
                                    email: 'owner@constructin.com.br',
                                    name: 'Construct IN',
                                    surname: '',
                                },
                                to_review_at: null,
                                closed_at: null,
                            },
                        ],
                    },
                    {
                        id: 10768,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5293-158fe03c-0436-4247-9ea8-d6e3df4aaa98.jpg?alt=media&token=71c129a4-cd32-41ce-83ae-cb1934ab80b5',
                        date: '24/06/2021 00:00',
                        yaw_offset: 157.165,
                        issues: [],
                    },
                    {
                        id: 10767,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5293-a4a003fa-637e-4586-87d6-8c8da3f8b2cd.jpg?alt=media&token=73e9dc98-1791-4bcb-a18b-8e515e4c4c05',
                        date: '29/05/2021 00:00',
                        yaw_offset: -8.10268,
                        issues: [],
                    },
                    {
                        id: 10766,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5293-cd774c18-dfdd-43c3-ac93-45cbf2e3f7ce.jpg?alt=media&token=8f546a2f-1054-4d61-a9bc-a211c1ed8cd4',
                        date: '20/05/2021 00:00',
                        yaw_offset: 84.375,
                        issues: [],
                    },
                    {
                        id: 10765,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5293-1fc6a848-3401-4df7-92df-e862122d3e27.jpg?alt=media&token=cc5837b1-6da7-4e53-ac8b-06532571d3c9',
                        date: '13/05/2021 00:00',
                        yaw_offset: -78.4152,
                        issues: [],
                    },
                    {
                        id: 10764,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5293-54aa7e35-77db-421a-b94c-d4272849a007.jpg?alt=media&token=5576fb54-b633-4fa4-9d39-9d56c930003d',
                        date: '06/05/2021 00:00',
                        yaw_offset: -8.10268,
                        issues: [],
                    },
                ],
            },
            {
                id: 5288,
                name: 'Apto 1001 - Lavabo',
                x: 2968,
                y: 757,
                images: [
                    {
                        id: 10738,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F244-70d1-1564411187066.jpg?alt=media&token=70d1f5d4-21a0-4d4b-b9e2-150a0e7ebb98',
                        date: '29/07/2021 10:33',
                        yaw_offset: -9.50893,
                        issues: [],
                    },
                    {
                        id: 10737,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5288-110344cf-8145-443b-946f-905aa2d0b0fe.jpg?alt=media&token=51699db1-61ed-4777-825f-595d805c802b',
                        date: '24/06/2021 00:00',
                        yaw_offset: -13.7277,
                        issues: [],
                    },
                    {
                        id: 10736,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5288-2988a9ce-7ab2-4e33-9f87-331a6b3e4ab4.jpg?alt=media&token=66d8272e-4f5b-48d5-a41b-99e2befeb0ea',
                        date: '29/05/2021 00:00',
                        yaw_offset: 15.8036,
                        issues: [],
                    },
                    {
                        id: 10735,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5288-3db3cbc7-9302-490b-b4c7-e3eb9cea6c68.jpg?alt=media&token=a88f4f55-1bc1-4b15-98c7-d2f2283c5277',
                        date: '20/05/2021 00:00',
                        yaw_offset: -176.853,
                        issues: [],
                    },
                    {
                        id: 10734,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5288-8b698059-14e7-4e52-a707-290aa9383f51.jpg?alt=media&token=783c519a-4ae3-4366-b62f-341098d0a44b',
                        date: '13/05/2021 00:00',
                        yaw_offset: -1.07143,
                        issues: [],
                    },
                    {
                        id: 10733,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5288-65013df0-dd9b-4a8e-a3f5-33c4941288a1.jpg?alt=media&token=76056ff9-dafe-48bc-9fdb-281535ff5160',
                        date: '06/05/2021 00:00',
                        yaw_offset: -178.929,
                        issues: [],
                    },
                    {
                        id: 10732,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5288-f5a289aa-8469-453e-91cb-393426fb0057.jpg?alt=media&token=0d28d959-317d-4334-8b20-6d0e32506c69',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5283,
                name: 'Apto 1001 - Área Social',
                x: 975,
                y: 818,
                images: [
                    {
                        id: 10706,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F239-6313-1564411147074.jpg?alt=media&token=63130c50-6868-4e40-a698-34eda7f2bf62',
                        date: '29/07/2021 10:32',
                        yaw_offset: 11.9196,
                        issues: [],
                    },
                    {
                        id: 10705,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5283-18e0ef80-2697-4d2b-b1d2-8f5e75c390b9.jpg?alt=media&token=781ca9e6-1e6f-4ae0-b705-16e9d57191fe',
                        date: '24/06/2021 00:00',
                        yaw_offset: -12.3214,
                        issues: [
                            {
                                id: 5941,
                                code: 5,
                                priority: 'low',
                                title: 'Terminabilidade dry-wall',
                                text: 'Atentar para armazenamento das esquadrias para não trancar demais serviços, como no exemplo, as janelas não permitiram finalizar tanto a tubulação, quanto o fechamento da parede.',
                                status: 'open',
                                due_days: -1,
                                due_date: '17/11/2021',
                                type: {
                                    id: 978,
                                    label: 'Ação',
                                    name: 'Organizar',
                                },
                                cause: {
                                    id: 646,
                                    label: 'Segurança',
                                    name: 'Organização do canteiro',
                                },
                                sector: {
                                    id: 347,
                                    name: 'a',
                                },
                                floorplan: {
                                    id: 503,
                                    name: '10º Pavimento - ED. Residencial',
                                },
                                viewpoint: {
                                    id: 5283,
                                    name: 'Apto 1001 - Área Social',
                                },
                                image: {
                                    id: 10705,
                                    date: '24/06/2019 00:00',
                                },
                                pitch: -12.5665,
                                yaw: -80.5993,
                                thumbnail:
                                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F3e504391-385a-4ad5-b1f2-7c6e22cac085.png?alt=media&token=9e288efc-9193-4836-850a-806fa4c6bc83',
                                attachment_thumbnail: null,
                                tags: [
                                    {
                                        id: 170,
                                        members: [
                                            {
                                                email: 'tales@constructin.com.br',
                                            },
                                            {
                                                email: 'lucas.pandolfo@constructin.com.br',
                                            },
                                            {
                                                email: 'emilio.bier@constructin.com.br',
                                            },
                                            {
                                                email: 'mario.magela@constructin.com.br',
                                            },
                                            {
                                                email: 'emerson@sqgroup.com.br',
                                            },
                                            {
                                                email: 'kelvin.montini@constructin.com.br',
                                            },
                                            {
                                                email: 'naomi.trindade@constructin.com.br',
                                            },
                                            {
                                                email: 'matheus.pandolfo@constructin.com.br',
                                            },
                                            {
                                                email: 'isis.gonzaga12@gmail.com',
                                            },
                                            {
                                                email: 'ryan.simon@constructin.com.br',
                                            },
                                            {
                                                email: 'jessie.spencer@constructin.com.br',
                                            },
                                            {
                                                email: 'leonardo.henrique@constructin.com.br',
                                            },
                                            {
                                                email: 'lucas.oliveira@constructin.com.br',
                                            },
                                            {
                                                email: 'maria.julia@constructin.com.br',
                                            },
                                            {
                                                email: 'lenon.lencina@constructin.com.br',
                                            },
                                            {
                                                email: 'leonardo.lopes@constructin.com.br',
                                            },
                                        ],
                                    },
                                ],
                                subjects: [],
                                comment_count: 16,
                                events: [
                                    {
                                        id: 13781,
                                        type: 'comment',
                                        comment: {
                                            id: 13781,
                                            text: 'entendido, vai ser feito!',
                                            edited: false,
                                            attachments: [],
                                        },
                                        created_at: '17/11/2021 14:17',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                ],
                                attachments: [],
                                created_at: '17/11/2021 14:01',
                                created_by: {
                                    id: 657,
                                    email: 'owner@constructin.com.br',
                                    name: 'Construct IN',
                                    surname: '',
                                },
                                to_review_at: null,
                                closed_at: null,
                            },
                        ],
                    },
                    {
                        id: 10704,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5283-9c541695-b026-44c8-9486-d4c17de871fb.jpg?alt=media&token=a2eae21c-ad8a-4ce7-8845-764925fc5f60',
                        date: '29/05/2021 00:00',
                        yaw_offset: 75.2679,
                        issues: [],
                    },
                    {
                        id: 10703,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5283-60b17ea3-9d73-4fac-9633-a65f4f48da15.jpg?alt=media&token=c6055366-854b-481b-95f4-accf2dd7d96e',
                        date: '20/05/2021 00:00',
                        yaw_offset: 77.3438,
                        issues: [],
                    },
                    {
                        id: 10702,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5283-0aa2e73d-5e8e-499a-ad95-6701532ba914.jpg?alt=media&token=cc88aaf1-483a-4628-affb-df4bf7f24d7e',
                        date: '13/05/2021 00:00',
                        yaw_offset: 179.665,
                        issues: [],
                    },
                    {
                        id: 10700,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5283-c58a145c-60c4-49e4-a415-b4a13ec9b9d6.jpg?alt=media&token=be96e0ae-28b8-4aa8-9c0c-97b07062938f',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5286,
                name: 'Apto 1001 - Área de Serviço',
                x: 2988,
                y: 428,
                images: [
                    {
                        id: 10724,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F242-e9de-1564411147852.jpg?alt=media&token=e9debd9d-f6ec-4cc4-ab67-c47cea5c04cb',
                        date: '29/07/2021 10:33',
                        yaw_offset: -84.375,
                        issues: [],
                    },
                    {
                        id: 10723,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5286-9c77084d-fbcd-45a7-995e-37f9e41c4a88.jpg?alt=media&token=8fe6258c-3683-4cfa-a198-afef121e9cd9',
                        date: '24/06/2021 00:00',
                        yaw_offset: 2.47768,
                        issues: [],
                    },
                    {
                        id: 10722,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5286-9c11b654-e4b8-47b0-9d79-2b7a157ce6c6.jpg?alt=media&token=f69f67bd-a738-4d9a-98c2-f00f474d91fc',
                        date: '20/05/2021 00:00',
                        yaw_offset: -0.334821,
                        issues: [],
                    },
                    {
                        id: 10720,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5286-4a51a5fc-343b-48c1-bb51-ed624810371f.jpg?alt=media&token=3c2571c1-2b22-4fd3-8fbb-6c1d02dc4eb2',
                        date: '13/05/2021 00:00',
                        yaw_offset: 0,
                        issues: [],
                    },
                    {
                        id: 10721,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5286-84dbf4a2-8836-4791-87e0-fc1fc8764036.jpg?alt=media&token=35ece4c9-7379-4b3f-bbb1-f60008ffff2f',
                        date: '13/05/2021 00:00',
                        yaw_offset: 5.625,
                        issues: [],
                    },
                    {
                        id: 10719,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5286-ec6da144-c6de-4c2c-be28-b2ffc18ad5ed.jpg?alt=media&token=998b9025-fd20-4853-ac58-ac47cfa05be6',
                        date: '06/05/2021 00:00',
                        yaw_offset: 76.2723,
                        issues: [],
                    },
                    {
                        id: 10718,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5286-6a1fccfc-6f24-4759-8212-6a006280a6f0.jpg?alt=media&token=8889303d-8384-4527-b86b-1c1466bc50f0',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5273,
                name: 'Apto 1002 - Banho Dormitório 01',
                x: 3325,
                y: 2285,
                images: [
                    {
                        id: 10641,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F229-2224-1564411078503.jpg?alt=media&token=2224af77-6b81-4d2d-9317-ed8d0cd9505a',
                        date: '29/07/2021 10:30',
                        yaw_offset: -168.08,
                        issues: [],
                    },
                    {
                        id: 10640,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5273-c290f65c-ca3d-456e-922b-6fb87fead65c.jpg?alt=media&token=78efb5cd-8f88-4afd-bf24-c1cac2d598f3',
                        date: '29/05/2021 00:00',
                        yaw_offset: 122.009,
                        issues: [],
                    },
                    {
                        id: 10639,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5273-bedc3fe5-912a-448a-af4e-5784b51214d5.jpg?alt=media&token=a7ecea29-19f8-4b97-b438-e03c311105eb',
                        date: '20/05/2021 00:00',
                        yaw_offset: -3.48214,
                        issues: [],
                    },
                    {
                        id: 10638,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5273-f8311e62-18cb-47ec-8c4b-1b23048bc8f3.jpg?alt=media&token=5fe8e600-f8bd-476e-8eb0-7ab366c9f32d',
                        date: '13/05/2021 00:00',
                        yaw_offset: 5.95982,
                        issues: [],
                    },
                    {
                        id: 10637,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5273-12511b98-d874-4755-96b7-4084d8def03e.jpg?alt=media&token=3ac3b57a-a068-4617-b84a-290a455373f9',
                        date: '06/05/2021 00:00',
                        yaw_offset: 171.897,
                        issues: [],
                    },
                    {
                        id: 10636,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5273-654c630d-ec6d-4976-9811-a2d6b1ee3e13.jpg?alt=media&token=470324b7-42b1-4e39-a9d8-76825408b3e5',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5275,
                name: 'Apto 1002 - Banho Dormitório 02',
                x: 5221,
                y: 2215,
                images: [
                    {
                        id: 10652,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F231-2328-1564411050300.jpg?alt=media&token=2328b588-1b69-4963-aa44-dad77de792c5',
                        date: '29/07/2021 10:30',
                        yaw_offset: 3.88393,
                        issues: [],
                    },
                    {
                        id: 10651,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5275-89e30be8-9f5e-4d6c-bbe9-a6bb179f8e09.jpg?alt=media&token=6011e762-a209-4d19-81fe-7184c9826f8c',
                        date: '29/05/2021 00:00',
                        yaw_offset: -10.5804,
                        issues: [],
                    },
                    {
                        id: 10650,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5275-231ceee2-8cca-4e0f-bdbb-7ccef82ec3b5.jpg?alt=media&token=f44a36ff-230c-453e-b4d3-902663484a6c',
                        date: '20/05/2021 00:00',
                        yaw_offset: 3.14732,
                        issues: [],
                    },
                    {
                        id: 10649,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5275-b6ef27bf-1991-4652-b760-7765d644a6cf.jpg?alt=media&token=f43afd4f-2cfc-4688-8127-7e41e8136d2e',
                        date: '13/05/2021 00:00',
                        yaw_offset: -7.36607,
                        issues: [],
                    },
                    {
                        id: 10648,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5275-a728cb30-8d38-443e-8d8a-0ea091dbadc4.jpg?alt=media&token=517b3c3d-a062-41e0-b5fb-a389f166f126',
                        date: '06/05/2021 00:00',
                        yaw_offset: 85.0446,
                        issues: [],
                    },
                    {
                        id: 10647,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5275-003c394c-d650-4a66-8d17-eeabe5874659.jpg?alt=media&token=28995eac-85e6-4829-b242-c4838004652b',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5271,
                name: 'Apto 1002 - Circulação',
                x: 3375,
                y: 1901,
                images: [
                    {
                        id: 10628,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F227-59e7-1564411077787.jpg?alt=media&token=59e7ad8e-9ebd-4bbe-b89f-d6725b1e4c9d',
                        date: '29/07/2021 10:30',
                        yaw_offset: 27.4554,
                        issues: [],
                    },
                    {
                        id: 10627,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5271-c82146af-6fb6-4cb1-8445-a261657ff8c5.jpg?alt=media&token=3ef7ab52-3e5a-47ab-be28-6c085eb82f83',
                        date: '29/05/2021 00:00',
                        yaw_offset: -12.3214,
                        issues: [],
                    },
                    {
                        id: 10626,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5271-0ee09556-f251-4ee5-8d9b-38703889d5fb.jpg?alt=media&token=8b8508eb-713b-4057-b0a5-777d89c54016',
                        date: '20/05/2021 00:00',
                        yaw_offset: -50.625,
                        issues: [],
                    },
                    {
                        id: 10624,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5271-593593c2-67ea-40ef-8073-bdcd5963ca1e.jpg?alt=media&token=faa237a7-754d-4f2b-adcd-848e0eec1ffa',
                        date: '06/05/2021 00:00',
                        yaw_offset: -32.0089,
                        issues: [],
                    },
                    {
                        id: 10623,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5271-1f7e07c1-228e-4e1f-8996-fbabb8ef7f00.jpg?alt=media&token=a784fdc4-9fd8-491c-8d64-a6ad8ec8073e',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5277,
                name: 'Apto 1002 - Circulação 02',
                x: 2757,
                y: 1901,
                images: [
                    {
                        id: 10664,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5277-b9c0450e-7553-4517-970e-843a01eb1157.jpg?alt=media&token=cae4baf1-50f8-4cc1-a703-11652e63142e',
                        date: '24/06/2021 00:00',
                        yaw_offset: 159.643,
                        issues: [],
                    },
                    {
                        id: 10663,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5277-41cadfde-0bc2-481d-a2f2-040401705d0f.jpg?alt=media&token=a9152b9d-b5d1-4f76-9a30-bc648ab17451',
                        date: '29/05/2021 00:00',
                        yaw_offset: -9.84375,
                        issues: [],
                    },
                    {
                        id: 10662,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5277-e87629c9-0795-4f17-93c2-b9eecf4f1bb1.jpg?alt=media&token=196f44a5-a006-4d3d-8957-cdc3d2c0559f',
                        date: '20/05/2021 00:00',
                        yaw_offset: -1.07143,
                        issues: [],
                    },
                    {
                        id: 10661,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5277-ed675807-ff5b-46e0-bc38-efe582cbc656.jpg?alt=media&token=6f45d1cf-1022-4f83-875b-9a75a68ea061',
                        date: '13/05/2021 00:00',
                        yaw_offset: -72.7902,
                        issues: [],
                    },
                    {
                        id: 10660,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5277-11ac0a7d-022f-4794-ab5d-813501cbffc3.jpg?alt=media&token=2aec7fa8-80a1-483c-b39a-bee0c6b0287c',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5278,
                name: 'Apto 1002 - Cozinha',
                x: 2223,
                y: 2253,
                images: [
                    {
                        id: 10671,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F234-9f8b-1564411115206.jpg?alt=media&token=9f8bc940-623c-48de-89f5-738db6043b2f',
                        date: '29/07/2021 10:31',
                        yaw_offset: -120.268,
                        issues: [],
                    },
                    {
                        id: 10670,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5278-96859c3d-9d5d-46ff-8e57-95e0692f56fe.jpg?alt=media&token=74d17625-e9dc-430a-9ff3-598d1f7b5a3a',
                        date: '24/06/2021 00:00',
                        yaw_offset: 162.455,
                        issues: [],
                    },
                    {
                        id: 10669,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5278-e2d81c93-cace-4267-91d7-f79ca62aecb2.jpg?alt=media&token=fffcb2ee-470a-44bf-ad8f-c44aba9e72b2',
                        date: '29/05/2021 00:00',
                        yaw_offset: -11.25,
                        issues: [],
                    },
                    {
                        id: 10668,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5278-759b7d18-8575-4273-81d3-8408a8ead2b0.jpg?alt=media&token=69627f14-18c0-4681-a26b-9a1a785c0b96',
                        date: '20/05/2021 00:00',
                        yaw_offset: 0,
                        issues: [],
                    },
                    {
                        id: 10667,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5278-237d8df1-b74c-40ea-a325-552021ebb0d5.jpg?alt=media&token=346e91da-3fd6-4ed6-b1bf-5147119d3c22',
                        date: '13/05/2021 00:00',
                        yaw_offset: 13.7277,
                        issues: [],
                    },
                    {
                        id: 10666,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5278-1845f7d0-405b-4309-b00f-35a16a7e0b5b.jpg?alt=media&token=5ee82115-fbf2-428b-8fa6-9fdab8fb58c4',
                        date: '06/05/2021 00:00',
                        yaw_offset: -162.455,
                        issues: [],
                    },
                    {
                        id: 10665,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5278-6b274495-ff6d-456c-944e-4c988b28e01b.jpg?alt=media&token=ae1f2f27-bbb6-4800-af7e-d7e365499401',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5279,
                name: 'Apto 1002 - Cozinha 02',
                x: 2543,
                y: 2555,
                images: [
                    {
                        id: 10678,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F235-b8df-1564411115207.jpg?alt=media&token=b8df4369-30e1-43c8-ac4b-046e13299807',
                        date: '29/07/2021 10:31',
                        yaw_offset: 99.8438,
                        issues: [],
                    },
                    {
                        id: 10677,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5279-7b132278-86dd-4fce-8186-3c37cee642d5.jpg?alt=media&token=cb5af015-b7a6-4211-9e5f-d3df43eab0d5',
                        date: '29/05/2021 00:00',
                        yaw_offset: -20.0223,
                        issues: [],
                    },
                    {
                        id: 10676,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5279-8a8bb285-07fa-40e8-a148-4a0aaf450f30.jpg?alt=media&token=e7f946c8-1ff3-471d-aa0a-1169ec3c7f47',
                        date: '20/05/2021 00:00',
                        yaw_offset: 2.14286,
                        issues: [],
                    },
                    {
                        id: 10674,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5279-9ec2b9b3-1cd0-471d-8da0-2cdabd600fb4.jpg?alt=media&token=e40da69d-36f0-4ddf-bb8e-e7ed8f592643',
                        date: '13/05/2021 00:00',
                        yaw_offset: 0,
                        issues: [],
                    },
                    {
                        id: 10675,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5279-27206f60-156b-4b74-af0f-8c5d67a38f61.jpg?alt=media&token=e2193265-f3cd-4ae5-987a-f8ab4e1190fa',
                        date: '13/05/2021 00:00',
                        yaw_offset: -2.8125,
                        issues: [],
                    },
                    {
                        id: 10673,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5279-7c65630c-105b-4eb6-931a-3925a2516c40.jpg?alt=media&token=e1453af7-7a45-49db-b3b6-f93b773efbbd',
                        date: '06/05/2021 00:00',
                        yaw_offset: 82.6339,
                        issues: [],
                    },
                    {
                        id: 10672,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5279-ce94e2e9-c188-4d21-a311-0ed95690ee97.jpg?alt=media&token=d7a0429c-fce0-4276-8957-f17dbb7fdd09',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5272,
                name: 'Apto 1002 - Dormitório 01',
                x: 3862,
                y: 2338,
                images: [
                    {
                        id: 10635,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F228-8b56-1564411077786.jpg?alt=media&token=8b56dbee-39e8-47c5-9345-a7476fd3f8ab',
                        date: '29/07/2021 10:30',
                        yaw_offset: -70.3125,
                        issues: [
                            {
                                id: 5940,
                                code: 4,
                                priority: 'medium',
                                title: 'Organização canteiro',
                                text: 'Eng. Leonardo, favor pedir para equipe organizar local de trabalho após terminar serviço.',
                                status: 'in_review',
                                due_days: 0,
                                due_date: '18/11/2021',
                                type: {
                                    id: 976,
                                    label: 'Ação',
                                    name: 'Executar',
                                },
                                cause: {
                                    id: 646,
                                    label: 'Segurança',
                                    name: 'Organização do canteiro',
                                },
                                sector: {
                                    id: 347,
                                    name: 'a',
                                },
                                floorplan: {
                                    id: 503,
                                    name: '10º Pavimento - ED. Residencial',
                                },
                                viewpoint: {
                                    id: 5272,
                                    name: 'Apto 1002 - Dormitório 01',
                                },
                                image: {
                                    id: 10635,
                                    date: '29/07/2019 10:30',
                                },
                                pitch: -54.7041,
                                yaw: -8.84038,
                                thumbnail:
                                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F0ba43364-c258-4189-8dc2-ede9a584b7b3.png?alt=media&token=667a9307-6a92-4766-83ef-4afb5bed45b4',
                                attachment_thumbnail: null,
                                tags: [
                                    {
                                        id: 170,
                                        members: [
                                            {
                                                email: 'leonardo.henrique@constructin.com.br',
                                            },
                                        ],
                                    },
                                ],
                                subjects: [],
                                comment_count: 2,
                                events: [
                                    {
                                        id: 13782,
                                        type: 'comment',
                                        comment: {
                                            id: 13782,
                                            text: 'ótimo ponto, vai ser resolvido ',
                                            edited: false,
                                            attachments: [],
                                        },
                                        created_at: '17/11/2021 14:17',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13798,
                                        type: 'to_review',
                                        comment: null,
                                        created_at: '18/11/2021 05:27',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13799,
                                        type: 'comment',
                                        comment: {
                                            id: 13799,
                                            text: 'Resolvido!',
                                            edited: false,
                                            attachments: [],
                                        },
                                        created_at: '18/11/2021 05:27',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                ],
                                attachments: [],
                                created_at: '17/11/2021 13:58',
                                created_by: {
                                    id: 657,
                                    email: 'owner@constructin.com.br',
                                    name: 'Construct IN',
                                    surname: '',
                                },
                                to_review_at: '18/11/2021 05:27',
                                closed_at: null,
                            },
                        ],
                    },
                    {
                        id: 10634,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5272-6bee524c-3ae4-492e-91a0-f111bb66ca5d.jpg?alt=media&token=66cefda5-3201-40d1-83c3-e13845e39590',
                        date: '24/06/2021 00:00',
                        yaw_offset: -124.42,
                        issues: [],
                    },
                    {
                        id: 10633,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5272-de0bebdd-b1a1-4204-b9bf-d7e352236f5d.jpg?alt=media&token=e736a0b9-c121-4a68-88d0-0d92f549ebc5',
                        date: '29/05/2021 00:00',
                        yaw_offset: -171.562,
                        issues: [],
                    },
                    {
                        id: 10632,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5272-9554d604-a341-489e-8295-c56df475c579.jpg?alt=media&token=4b6c0724-ab44-492b-8fc1-b5e1f5df92a1',
                        date: '20/05/2021 00:00',
                        yaw_offset: -93.1473,
                        issues: [],
                    },
                    {
                        id: 10631,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5272-d9ac920b-c9b1-4c2c-9ada-f7dbc954879c.jpg?alt=media&token=2c0aebc0-2169-41ab-8502-6485aab8f5e7',
                        date: '13/05/2021 00:00',
                        yaw_offset: 2.47768,
                        issues: [],
                    },
                    {
                        id: 10630,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5272-28c67be5-bf9b-4a84-9495-98055a715be4.jpg?alt=media&token=ea969ceb-459b-42ee-be4f-1c42ae2209e5',
                        date: '06/05/2021 00:00',
                        yaw_offset: 98.4375,
                        issues: [],
                    },
                    {
                        id: 10629,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5272-88678a33-afd1-4c9b-867e-e8d63baa38d8.jpg?alt=media&token=14ed42e9-e94e-4140-883e-7b0fbca889b3',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5274,
                name: 'Apto 1002 - Dormitório 02',
                x: 4607,
                y: 2232,
                images: [
                    {
                        id: 10646,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F230-305d-1564411077787.jpg?alt=media&token=305dfa7e-c81a-47b7-9993-0847cdf82c88',
                        date: '29/07/2021 10:30',
                        yaw_offset: 85.4464,
                        issues: [],
                    },
                    {
                        id: 10645,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5274-d00bf929-467a-4754-9ead-0a3071b92119.jpg?alt=media&token=ff6f96c1-5894-4518-ae6b-f3517cf100dd',
                        date: '20/05/2021 00:00',
                        yaw_offset: 0.334821,
                        issues: [],
                    },
                    {
                        id: 10644,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5274-6e2577a7-7351-494b-9faf-85c9990a99cf.jpg?alt=media&token=1f71c055-c0eb-4108-95a7-4a568f202478',
                        date: '13/05/2021 00:00',
                        yaw_offset: -1.74107,
                        issues: [],
                    },
                    {
                        id: 10643,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5274-9115c826-0704-4fa5-8529-4bddd7764f85.jpg?alt=media&token=cfbd2275-c3e0-46d4-9a53-30262703e6c1',
                        date: '06/05/2021 00:00',
                        yaw_offset: 142.366,
                        issues: [],
                    },
                    {
                        id: 10642,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5274-aa52eecf-10bf-4466-96c1-dedb663314a4.jpg?alt=media&token=27e7df9d-a862-4bef-bd39-301000bd915b',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5276,
                name: 'Apto 1002 - Lavabo',
                x: 2964,
                y: 2183,
                images: [
                    {
                        id: 10659,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F232-886e-1564411078529.jpg?alt=media&token=886ed548-bdf9-4956-b401-1ec6ba960595',
                        date: '29/07/2021 10:31',
                        yaw_offset: -52.0312,
                        issues: [],
                    },
                    {
                        id: 10658,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5276-baec58b6-62b0-4c39-93c2-3380b96ee93f.jpg?alt=media&token=8ea21873-ad7a-4e4c-9b97-1ed354716595',
                        date: '24/06/2021 00:00',
                        yaw_offset: -106.875,
                        issues: [],
                    },
                    {
                        id: 10657,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5276-bef7b322-d205-4f32-b8b1-556c31c4098d.jpg?alt=media&token=0f378cc1-aa73-42d6-80e5-c1e7868958a8',
                        date: '29/05/2021 00:00',
                        yaw_offset: -13.3929,
                        issues: [],
                    },
                    {
                        id: 10656,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5276-c7eece8c-ba80-45eb-87c1-7c668495b30d.jpg?alt=media&token=1964c972-dd02-4df0-b6e9-21c76236c18a',
                        date: '20/05/2021 00:00',
                        yaw_offset: -0.669643,
                        issues: [],
                    },
                    {
                        id: 10655,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5276-4abc9a3d-c6a3-4e2a-89b7-a036f69b23f8.jpg?alt=media&token=fdc50e10-eda7-4b86-905b-6bbfa2c57f6a',
                        date: '13/05/2021 00:00',
                        yaw_offset: 2.14286,
                        issues: [],
                    },
                    {
                        id: 10654,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5276-98b325c4-38be-41d6-b28e-2f9b31a55243.jpg?alt=media&token=eaa39d33-84d1-4733-bbe2-672603e37768',
                        date: '06/05/2021 00:00',
                        yaw_offset: 163.125,
                        issues: [],
                    },
                    {
                        id: 10653,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5276-72aaeea1-b987-42f9-a78c-b808e3bb3a3d.jpg?alt=media&token=2fa89314-f9c7-4c66-8f02-6c08b734ea47',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5282,
                name: 'Apto 1002 - Área Social',
                x: 952,
                y: 2018,
                images: [
                    {
                        id: 10698,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5282-966c9c81-b54e-4f82-a9bd-b86141732ab7.jpg?alt=media&token=0720d29a-5420-4db7-b678-236565307b83',
                        date: '24/06/2021 00:00',
                        yaw_offset: 160.647,
                        issues: [],
                    },
                    {
                        id: 10697,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5282-15a45aba-a95e-4e12-9f79-16d896d6b744.jpg?alt=media&token=671fe11f-8728-41c8-be29-d2c23f1edfb2',
                        date: '29/05/2021 00:00',
                        yaw_offset: -12.9911,
                        issues: [],
                    },
                    {
                        id: 10696,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5282-c7672756-7899-438c-865d-2558a59f150f.jpg?alt=media&token=67d36068-83a7-49ea-b7e9-3f2ffea6e1b2',
                        date: '20/05/2021 00:00',
                        yaw_offset: 3.48214,
                        issues: [],
                    },
                    {
                        id: 10695,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5282-17c42a68-3838-4c65-94a9-ce651aa14ef2.jpg?alt=media&token=b293e654-5d95-4f37-b5a0-25e18db3f065',
                        date: '13/05/2021 00:00',
                        yaw_offset: 3.14732,
                        issues: [],
                    },
                    {
                        id: 10694,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5282-58787099-026f-40db-b942-4de08d59c75c.jpg?alt=media&token=7a03cc1a-97f9-4c67-892e-c49030679818',
                        date: '06/05/2021 00:00',
                        yaw_offset: -146.585,
                        issues: [],
                    },
                    {
                        id: 10693,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5282-487d325d-dafc-433c-bfb8-db952ca9e57e.jpg?alt=media&token=6a6e74bb-2a28-47e3-be63-2a4bee72be06',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [
                            {
                                id: 5937,
                                code: 1,
                                priority: 'high',
                                title: 'Fechamento Dry-wall',
                                text: 'Verificar interferência de tubulação hidráulica com tubulação elétrica.\nAnálise junto ao Matheus, nosso projetista HIDRO/ELE.',
                                status: 'in_review',
                                due_days: 0,
                                due_date: '18/11/2021',
                                type: {
                                    id: 977,
                                    label: 'Ação',
                                    name: 'Reparar',
                                },
                                cause: {
                                    id: 652,
                                    label: 'Projeto',
                                    name: 'Conflito entre projetos',
                                },
                                sector: {
                                    id: 347,
                                    name: 'a',
                                },
                                floorplan: {
                                    id: 503,
                                    name: '10º Pavimento - ED. Residencial',
                                },
                                viewpoint: {
                                    id: 5282,
                                    name: 'Apto 1002 - Área Social',
                                },
                                image: {
                                    id: 10693,
                                    date: '29/04/2019 00:00',
                                },
                                pitch: 6.95426,
                                yaw: -30.1698,
                                thumbnail:
                                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F6032ac11-4454-41c0-8c6c-a658d2e4deb6.png?alt=media&token=d651b54c-1936-4562-8384-76e4a8a1bf05',
                                attachment_thumbnail: null,
                                tags: [
                                    {
                                        id: 170,
                                        members: [
                                            {
                                                email: 'tales@constructin.com.br',
                                            },
                                            {
                                                email: 'matheus.pandolfo@constructin.com.br',
                                            },
                                        ],
                                    },
                                ],
                                subjects: [
                                    {
                                        id: 1174,
                                        code: 'ELE',
                                        name: 'Elétrica',
                                    },
                                    {
                                        id: 1179,
                                        code: 'HID',
                                        name: 'Hidrossanitário',
                                    },
                                ],
                                comment_count: 4,
                                events: [
                                    {
                                        id: 13792,
                                        type: 'comment',
                                        comment: {
                                            id: 13792,
                                            text: 'Problema resolvido, projeto hidráulico será alterado, conforme anexo.',
                                            edited: false,
                                            attachments: [],
                                        },
                                        created_at: '18/11/2021 05:26',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13793,
                                        type: 'comment',
                                        comment: {
                                            id: 13793,
                                            text: '',
                                            edited: false,
                                            attachments: [
                                                {
                                                    id: 931,
                                                    name: 'ProjetoCIN.png',
                                                    url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F87b9d228-ace6-4fd0-8c9d-87fe17bf3e06.png?alt=media&token=0edd9318-6dc4-4495-829c-5e31fc088bf3',
                                                    type: 'png',
                                                },
                                            ],
                                        },
                                        created_at: '18/11/2021 05:26',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                    {
                                        id: 13794,
                                        type: 'to_review',
                                        comment: null,
                                        created_at: '18/11/2021 05:27',
                                        created_by: {
                                            id: 657,
                                            email: 'owner@constructin.com.br',
                                            name: 'Construct IN',
                                            surname: '',
                                        },
                                    },
                                ],
                                attachments: [],
                                created_at: '17/11/2021 13:39',
                                created_by: {
                                    id: 657,
                                    email: 'owner@constructin.com.br',
                                    name: 'Construct IN',
                                    surname: '',
                                },
                                to_review_at: '18/11/2021 05:27',
                                closed_at: null,
                            },
                        ],
                    },
                ],
            },
            {
                id: 5280,
                name: 'Apto 1002 - Área de Serviço',
                x: 2968,
                y: 2520,
                images: [
                    {
                        id: 10685,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F236-971f-1564411115203.jpg?alt=media&token=971f4464-02d6-45a3-87d0-7ac3bf441fe1',
                        date: '29/07/2021 10:31',
                        yaw_offset: -66.8304,
                        issues: [],
                    },
                    {
                        id: 10684,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5280-a8b2e904-e408-40dd-9627-f8d2a0daf7b8.jpg?alt=media&token=85a52887-e2ab-4e8e-893b-dee50e80b924',
                        date: '24/06/2021 00:00',
                        yaw_offset: 79.0848,
                        issues: [],
                    },
                    {
                        id: 10683,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5280-2113ca27-3a6c-47d2-9b0f-0ac21e0a134e.jpg?alt=media&token=f8e51aff-6017-4c78-8e09-408dc32db4ee',
                        date: '29/05/2021 00:00',
                        yaw_offset: -4.95536,
                        issues: [],
                    },
                    {
                        id: 10682,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5280-5c25cbf5-ba4b-4be5-99bc-b1eab2590254.jpg?alt=media&token=c446ce01-35eb-4c36-9909-407b823aa466',
                        date: '20/05/2021 00:00',
                        yaw_offset: 0,
                        issues: [],
                    },
                    {
                        id: 10681,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5280-23b9327a-c7ea-4a77-b5a4-e39473482877.jpg?alt=media&token=b0d26742-937c-45af-8d91-f324c1c60366',
                        date: '13/05/2021 00:00',
                        yaw_offset: -5.29018,
                        issues: [],
                    },
                    {
                        id: 10680,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5280-9d8f989d-69ae-49d3-ae9d-1b6cd7177596.jpg?alt=media&token=4721708d-0f8e-4852-bf03-c2a5943a67c9',
                        date: '06/05/2021 00:00',
                        yaw_offset: 102.991,
                        issues: [],
                    },
                    {
                        id: 10679,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5280-b1ad3fff-4abd-40a3-9021-ff1ad22eb3a9.jpg?alt=media&token=422999fd-c581-4e9e-9f45-e8474b5b9956',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5269,
                name: 'Escada',
                x: 3862,
                y: 1596,
                images: [
                    {
                        id: 10615,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F225-3378-1564411215418.jpg?alt=media&token=33786904-0380-4d4e-baa9-1f401c001cdc',
                        date: '29/07/2021 10:34',
                        yaw_offset: -62.5446,
                        issues: [],
                    },
                    {
                        id: 10614,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5269-28efa274-e8a6-4c11-9817-586d696b4909.jpg?alt=media&token=705f9f19-ad79-4090-9971-d23e10c06a83',
                        date: '24/06/2021 00:00',
                        yaw_offset: 85.0446,
                        issues: [],
                    },
                    {
                        id: 10613,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5269-8a81d3e0-7f8c-4621-adec-1c58e37c0c8a.jpg?alt=media&token=4fa23694-47d1-4c72-92ba-e2401389092b',
                        date: '29/05/2021 00:00',
                        yaw_offset: -8.10268,
                        issues: [],
                    },
                    {
                        id: 10612,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5269-a624cd3c-1dae-413c-8006-b7d381ce9c5a.jpg?alt=media&token=bf8d1914-ad08-4cb0-a100-76f469c6dcf8',
                        date: '20/05/2021 00:00',
                        yaw_offset: -5.95982,
                        issues: [],
                    },
                    {
                        id: 10611,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5269-e61f9781-a4bb-400f-a9bb-7226f6fbc362.jpg?alt=media&token=bc07ca6a-7211-4740-901f-700e72dd48b7',
                        date: '13/05/2021 00:00',
                        yaw_offset: 5.95982,
                        issues: [],
                    },
                    {
                        id: 10610,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5269-4a28b206-420a-4c5f-aa64-b77e2ba856c5.jpg?alt=media&token=a168ccca-bf8a-417c-a36b-3366672186ec',
                        date: '06/05/2021 00:00',
                        yaw_offset: -1.74107,
                        issues: [],
                    },
                    {
                        id: 10609,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5269-de8afa7d-3afb-40ff-be0e-a146306a3035.jpg?alt=media&token=8b412539-a6ab-493e-b98a-307836568573',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5270,
                name: 'Hall Serviço',
                x: 3435,
                y: 1473,
                images: [
                    {
                        id: 10622,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F226-87db-1564411050260.jpg?alt=media&token=87dba8ca-d274-4267-a8b1-02fafc5ab516',
                        date: '29/07/2021 10:29',
                        yaw_offset: -37.9688,
                        issues: [],
                    },
                    {
                        id: 10621,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5270-3b1bea90-1085-4fd5-bb44-262e466b8081.jpg?alt=media&token=f114730b-ba17-447f-90fd-96b6b2e422fc',
                        date: '24/06/2021 00:00',
                        yaw_offset: 68.1696,
                        issues: [],
                    },
                    {
                        id: 10620,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5270-819a60e9-10cc-4287-8e48-0e4db0c9c280.jpg?alt=media&token=ab2f84a0-c93f-4c16-8b7a-0ac910323ae4',
                        date: '29/05/2021 00:00',
                        yaw_offset: -8.4375,
                        issues: [],
                    },
                    {
                        id: 10619,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5270-f5c6c7c6-9032-408c-8ed9-8de4db45de89.jpg?alt=media&token=6ce5a3f7-7aa0-4c38-9d18-bcd173eb13c3',
                        date: '20/05/2021 00:00',
                        yaw_offset: -1.74107,
                        issues: [],
                    },
                    {
                        id: 10618,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5270-d0b10482-9731-49fc-8a6b-91b529841a67.jpg?alt=media&token=69868ac7-0203-4cd6-be90-dd8e86405f33',
                        date: '13/05/2021 00:00',
                        yaw_offset: 0.334821,
                        issues: [],
                    },
                    {
                        id: 10617,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5270-a376a065-d7b1-437c-ac24-f917ea6697b2.jpg?alt=media&token=0ef04751-5062-42a6-96f2-ec6dd52e5899',
                        date: '06/05/2021 00:00',
                        yaw_offset: 174.04,
                        issues: [],
                    },
                    {
                        id: 10616,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5270-62beba54-48d7-4733-96a6-560dd2ebd57b.jpg?alt=media&token=b3f82672-90be-4b7b-a7cb-f967411d2952',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5281,
                name: 'Hall Social',
                x: 2104,
                y: 1458,
                images: [
                    {
                        id: 10692,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F237-14b8-1564411116055.jpg?alt=media&token=14b8693a-091e-4ff7-a172-10ca446939b4',
                        date: '29/07/2021 10:32',
                        yaw_offset: -60.8036,
                        issues: [],
                    },
                    {
                        id: 10691,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5281-31bebe74-59fe-46ad-9dd1-7ba68d774cdb.jpg?alt=media&token=fb29b669-0f53-4c5e-baff-d0ea92abf565',
                        date: '24/06/2021 00:00',
                        yaw_offset: -7.76786,
                        issues: [],
                    },
                    {
                        id: 10690,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5281-13ddfc8c-ed83-440d-99c3-8a99e87233aa.jpg?alt=media&token=534c111f-2256-4c65-8b7f-c1245223ce17',
                        date: '29/05/2021 00:00',
                        yaw_offset: -98.1027,
                        issues: [],
                    },
                    {
                        id: 10689,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5281-12b40527-8545-4151-914e-de9d9faf828c.jpg?alt=media&token=bea6eaf7-509b-418e-8fef-2ee89e3840dd',
                        date: '20/05/2021 00:00',
                        yaw_offset: 2.14286,
                        issues: [],
                    },
                    {
                        id: 10688,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5281-d78ffc51-9109-4ede-806c-ea1ad986c500.jpg?alt=media&token=2af966d5-46c9-47f8-9009-ed754d8653c9',
                        date: '13/05/2021 00:00',
                        yaw_offset: 8.4375,
                        issues: [],
                    },
                    {
                        id: 10686,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5281-d56440c4-a883-47ab-a819-3cc8b369e784.jpg?alt=media&token=a4d9aa9a-2743-46c8-b48d-06a81b129ec4',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
            {
                id: 5268,
                name: 'Patamar Escada',
                x: 4706,
                y: 1470,
                images: [
                    {
                        id: 10608,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffolders%2Fviewpoints%2F224-b3a7-1564411215419.jpg?alt=media&token=b3a71dbf-da8e-4ec2-abb5-20fb04ec38de',
                        date: '29/07/2021 10:34',
                        yaw_offset: -97.0312,
                        issues: [],
                    },
                    {
                        id: 10607,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5268-3f21060b-af45-4f23-9223-9f30563585e1.jpg?alt=media&token=0832a223-ba76-4cd4-aa38-44079f9b974d',
                        date: '24/06/2021 00:00',
                        yaw_offset: -70.9821,
                        issues: [],
                    },
                    {
                        id: 10606,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5268-abe1c207-d6a7-489b-8319-b3f38977f24c.jpg?alt=media&token=2fb063eb-1607-41dd-aec2-e72e604d2b36',
                        date: '29/05/2021 00:00',
                        yaw_offset: -8.4375,
                        issues: [],
                    },
                    {
                        id: 10605,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5268-704b3bae-1ce6-485b-ac18-539d90f2062a.jpg?alt=media&token=d75764b0-4e7e-4ca3-ae73-03d30bc1226b',
                        date: '20/05/2021 00:00',
                        yaw_offset: 0.669643,
                        issues: [],
                    },
                    {
                        id: 10604,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5268-4f3098bc-0a36-40a2-8e67-98bb8093aebe.jpg?alt=media&token=93faec2c-a130-4be0-940b-8457e9e98fcb',
                        date: '13/05/2021 00:00',
                        yaw_offset: 3.14732,
                        issues: [],
                    },
                    {
                        id: 10603,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5268-e4b015bc-6bf0-4cfd-8455-276e2ab48ffb.jpg?alt=media&token=f90191b2-d40c-4056-bd29-9cd14dfb9cc4',
                        date: '06/05/2021 00:00',
                        yaw_offset: -76.6071,
                        issues: [],
                    },
                    {
                        id: 10602,
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Ffloorplans%2Fviewpoints%2F%2F5268-75a11d57-4ff3-4d64-8f86-f2879b907f0e.jpg?alt=media&token=833e4f41-729b-44a2-9548-bd55de57e395',
                        date: '29/04/2021 00:00',
                        yaw_offset: null,
                        issues: [],
                    },
                ],
            },
        ],
    },
]
